module.exports = "/_next/static/images/enterpriseDataCenters-d6b856b6e14d854bff88c2eec35921cf.webp";